module.exports = __webpack_public_path__ + "bundles/EventSubmission/assets/images/icons/star-9ef76fcee60ee767dbb356756bf3d003.svg";


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/assets/images/icons/star.svg
// module id = 617
// module chunks = 0